import getFormattedTime from "app/player/utils/getFormattedTime"
import { useAtomValue } from "jotai"
import { timeAtom } from "../state"

export default function useCurrentTime() {
  const time = useAtomValue(timeAtom)
  return getFormattedTime(time)
}
